<template>
  <div class="group">

    <input v-if="group.edit" v-model="color" type="color" class="form-control">
    <div v-else class="color-group" :style="{background: `rgb(${group.color_rgb})`}"></div>
    <input v-if="group.edit" type="text" v-model="group.name" class="form-control group-name">
    <span class="group-name" v-else>{{ group.name }}</span>
    <select v-if="group.edit" v-model="group.tone" name="" class="form-control" id="">
      <option v-for="(tone, key) in $TONES" :value="key">{{ tone.name }}</option>
    </select>
    <span v-else>{{ group.get_tone_display || "-" }}</span>
    <div class="buttons">
      <button v-if="group.edit" class="btn btn-sm btn-success text-white" type="button"
              @click="changeGroup"><i
          class="bi bi-check2"></i></button>
      <button v-if="group.edit" class="btn btn-sm btn-danger text-white" type="button"
              @click="$emit('cancel', group, index)"><i
          class="bi bi-x-lg"></i></button>
      <button v-if="group.id && !group.edit" class="btn btn-sm btn-success text-white" type="button"
              @click="group.edit = true;"><i
          class="bi bi-pencil"></i></button>
      <button v-if="group.id && !group.edit" class="btn btn-sm btn-danger text-white" type="button"
              @click="$emit('remove', group, index)"><i
          class="bi bi-trash"></i></button>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupItem",
  props: {
    group: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      color: ""
    }
  },
  mounted() {
    this.color = this.$func.rgbToHex(this.group.color_rgb);
  },
  methods: {
    changeGroup() {
      this.group.color_rgb = this.$func.hexToRgb(this.color);
      this.$emit('save', this.group, this.index)
    },
  },
  emits: ['save', 'cancel', 'remove']
}
</script>
<style scoped lang="scss">

.group {
  display: flex;
  gap: 10px;
  height: 30px;
  margin-bottom: 5px;

  .group-name {
    width: 50%;
    overflow: hidden;
    height: 30px;
    font-size: 14px;
    line-height: 14px;
  }

  input {
    height: 30px;

    &[type=color] {
      width: 30px;
      height: 30px;
      padding: 3px;
      flex: 0 0 auto;
      border-radius: 0;
    }

    //&[type=text] {
      //width: 345px;
    //}
  }

  select {
    width: 120px;
    height: 30px;
    line-height: 14px;
  }

  .buttons {
    margin-left: auto;
    display: flex;
    gap: 3px;
  }

  .color-group {
    height: 30px;
    width: 30px;
    flex: 0 0 auto;
  }
}

</style>